import React from "react";
import { Form, Message, Icon } from "semantic-ui-react";
import { useWaterBalanceT } from "../useWaterBalanceT";

// Paso 2 — Contexto. Días operativos y dotación se heredan de Social
// (days_worked + trabajadores por categoría/género), igual que la
// producción se hereda de Production — el Balance solo los lee, nunca los
// duplica. El riesgo hídrico (WRI/WWF) NO existe en ningún módulo hoy: es lo
// único que se pide acá como campo propio del Balance.
export function ContextoStep({ value, onChange, inheritedProduction, inheritedOperatingDays, inheritedStaffing }) {
  const t = useWaterBalanceT();
  const set = (campo) => (e, data) => onChange({ ...value, [campo]: data ? data.value : e.target.value });

  return (
    <div className="water-balance-step">
      <h3>{t("water_balance_context_title")}</h3>

      <Message info icon>
        <Icon name="info circle" />
        <Message.Content>
          <Message.Header>{t("water_balance_context_not_inherited_header")}</Message.Header>
          {t("water_balance_context_not_inherited_body")}
        </Message.Content>
      </Message>

      <Form>
        <Form.Group widths="equal">
          <Form.Input
            label={t("water_balance_operating_days_label")}
            disabled
            value={inheritedOperatingDays != null ? t("water_balance_operating_days_inherited", { valor: inheritedOperatingDays }) : t("water_balance_operating_days_missing")}
          />
          <Form.Input
            label={t("water_balance_staffing_label")}
            disabled
            value={inheritedStaffing != null ? t("water_balance_staffing_inherited", { valor: inheritedStaffing }) : t("water_balance_staffing_missing")}
          />
        </Form.Group>
        <Form.Input
          label={t("water_balance_production_label")}
          disabled
          value={
            inheritedProduction
              ? t("water_balance_production_inherited", { valor: inheritedProduction.value, unidad: inheritedProduction.unit || "" })
              : t("water_balance_production_missing")
          }
        />
        <Form.Group widths="equal">
          <Form.Input label={t("water_balance_wri_label")} placeholder="ej. Alto (3-4)" value={value.wriRisk} onChange={set("wriRisk")} />
          <Form.Input label={t("water_balance_wwf_label")} placeholder="ej. Medio-alto" value={value.wwfRisk} onChange={set("wwfRisk")} />
        </Form.Group>
        <Form.Input label={t("water_balance_geo_label")} value={value.geoNote} onChange={set("geoNote")} />
      </Form>
    </div>
  );
}

export default ContextoStep;
